export default __webpack_public_path__ + "static/media/002-monitor.be6c4062.svg";